import GDY_App from './GDY_App';
import GDY_NOISE_App from './GDY_NOISE_App';
// import ZMPG_App from './ZMPG_App';
// import ZMPG_WATER_App from './ZMPG_WATER_App';


function App() {
  // return window.location.href.includes('water') ? <ZMPG_WATER_App /> : <ZMPG_App/>;
  return window.location.href.includes('noise') ? <GDY_NOISE_App/> : <GDY_App/>;
}

export default App;
